import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.broadcast.json";

// `sp-broadcast` is a registered component rather than an app, so it has no plugin hook to install
// the instance on — the strings are read off the global composer directly.
export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "broadcast", fallbackMessages });

/**
 * Translates a broadcast string. Keys are relative to `frontend.broadcast`, which the i18n endpoint
 * serves as the message root, and resolve per client through that client's own locale files.
 *
 * @param {String} key
 * @returns {String}
 */
export function t(key) {
  return i18n.global.t(key);
}
